import hooks from 'larasnap/hooks';
import { Toast } from 'larasnap/support';

const FormValidation = form => {
    const getValidationFieldWrapper = element => {
        if (element.closest('.form-row').length > 0) {
            return element.closest('.form-row');
        } else {
            return element.parent();
        }
    };

    const getDatamodelFieldInstance = element => {
        const field = element.find(':input[data-is-datamodel-field-instance]');
        if (field.length > 0) {
            return field.data('instance');
        }
    };

    const applyValidationToField = (input, error) => {
        const wrapper = getValidationFieldWrapper(input);

        input.addClass('is-invalid');

        const contextBox = wrapper.find('.content-box');
        if (contextBox.length) {
            contextBox.addClass('is-invalid');
        }

        // If this field is part of a datamodel instance then let the field know
        // that there is a validation error
        const instance = getDatamodelFieldInstance(wrapper);
        if (instance) {
            instance.setValidationError(error.message);
        }

        if (input.data('no-error-message')) {
            return;
        }

        // Find the help block if exists, otherwise add it
        let helpBlock = wrapper.find('div.invalid-feedback');
        if (helpBlock.length === 0) {
            helpBlock = $(
                '<div class="error invalid-feedback" style="display: none"></div>',
            );

            if (wrapper.find('.row-value-inner').length > 0) {
                wrapper.find('.row-value-inner').append(helpBlock);
            } else {
                wrapper.append(helpBlock);
            }
        }

        helpBlock.html(error.message).show();

        // If this field is part of a tab then make that tab visible
        if (wrapper.closest('.tab-pane').length > 0) {
            const pane = wrapper.closest('.tab-pane');
            const id = pane.attr('id');
            const tabs = pane.closest('.tab-content').siblings('.nav-tabs');
            const link = tabs.find(`li a[href='#${id}']`);
            link.click();
        }
    };

    const clear = () => {
        form.find(':input').forEach(input => {
            const wrapper = getValidationFieldWrapper(input);

            wrapper.find('.is-invalid').removeClass('is-invalid');
            wrapper.find('.invalid-feedback').html('').hide();

            const instance = getDatamodelFieldInstance(wrapper);
            if (instance) {
                instance.setValidationError(null);
            }
        });

        hooks.run('validation-clear');
    };

    const apply = errors => {
        clear();

        /* if (form.datamodel()) {
            const vueApp = form.vueApp(form.datamodel().getName())
            if (vueApp) {
                vueApp.setValidationErrors(errors)
            }
        } */

        if (errors.length > 0) {
            const message = errors.some(error =>
                error.message.join(',').includes('required'),
            )
                ? 'Please fill in all required fields'
                : 'Please correct form errors';

            Toast.error(message);
        }

        const panelErrors = errors.filter(x => x.field === '[panel]');
        const fieldErrors = errors.filter(x => x.field !== '[panel]');

        applyPanelErrors(panelErrors);
        applyFieldErrors(fieldErrors);

        hooks.run('validation-apply', errors);
    };

    const applyPanelErrors = errors => {
        for (const error of errors) {
            form.panel().showError(error.message);
        }
    };

    const applyFieldErrors = errors => {
        errors.forEach(error => {
            applyValidationToField(getElement(error.field), error);

            form.find(`[data-display-error='${error.field}']`).each(
                function () {
                    applyValidationToField($(this), error);
                },
            );
        });
    };

    const getElement = field => {
        const element = form.find(`:input[name='${field}']`);
        if (element.length) {
            return element;
        } else {
            return form.find(`:input[name='${field}[]']`);
        }
    };

    return {
        apply,
        clear,
    };
};

export default FormValidation;
